import { gsap } from 'gsap';
import mixitup from 'mixitup';

const Recipes = {
  navUnderline: function() {
    if (!document.body.contains(document.querySelector('.post-type-archive-recipes'))) return false;

    let navLinks = document.querySelectorAll('.js-nav-link');
    let navUnderline = document.querySelector('.js-nav-underline');
    let navStyles = window.getComputedStyle(navUnderline);

    [...navLinks].forEach((link) => {
      let styles = window.getComputedStyle(link);
      let linkWidth = link.clientWidth;
      let trueWidth = linkWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
      link.dataset.width = trueWidth;

      console.log(`styles ${link}`, linkWidth);

      //   link.addEventListener('mouseover', (e) => {
      //     //gsap transform the underline to the width of the data-width attribute on the link

      //     const timeline = gsap.timeline({ defaults: { ease: 'power4.inOut' } });
      //     timeline.to(navUnderline, { duration: 0.3, x: e.target.offsetLeft }).to(navUnderline, { duration: 0.5, width: e.target.dataset.width }, '-=0.1');
      //   });

      link.addEventListener('click', (e) => {
        //remove active class from all links

        e.preventDefault();

        [...navLinks].forEach((link) => {
          link.classList.remove('active');
        });

        e.target.classList.add('active');

        const timeline = gsap.timeline({ defaults: { ease: 'power4.inOut' } });
        timeline.to(navUnderline, { duration: 0.3, x: e.target.offsetLeft }).to(navUnderline, { duration: 0.5, width: e.target.dataset.width }, '-=0.1');
      });
    });
  },
  preSortRecipes: function(mixer) {
    console.log('preSortRecipes');
    let hash = window.location.hash.substring(1);

    let validFilters = ['chardonnay', 'sauvignon-blanc', 'zinfandel', 'cabernet-sauvignon', 'merlot', 'pinot-noir'];
    let filter = validFilters.includes(hash) ? '.' + hash : 'all';

    // Activate the appropriate mixitup filter
    // let mixer = mixitup(containerEl);
    mixer.filter(filter);

    // Remove 'active' class from all links
    let navLinks = document.querySelectorAll('.js-nav-link');
    navLinks.forEach((link) => {
      link.classList.remove('active');
    });

    // Add 'active' class to the current filter
    let activeLink;
    if (filter === 'all') {
      activeLink = document.querySelector('.js-nav-link[data-filter="all"]');
    } else {
      activeLink = document.querySelector('.js-nav-link[data-filter="' + filter + '"]');
    }
    activeLink.classList.add('active');

    // For the mobile filter select element
    let selectElement = document.querySelector('#mixitup-filter-select');
    selectElement.value = filter;

    // To manually trigger a change event on the select element if you have attached an event handler
    let event = new Event('change');
    selectElement.dispatchEvent(event);

    // Animate the underline using GSAP
    let navUnderline = document.querySelector('.js-nav-underline');
    const timeline = gsap.timeline({ defaults: { ease: 'power4.inOut' } });
    timeline.to(navUnderline, { duration: 0.3, x: activeLink.offsetLeft }).to(navUnderline, { duration: 0.5, width: activeLink.dataset.width }, '-=0.1');
  },
  recipeMixitup: function() {
    if (!document.body.contains(document.querySelector('.post-type-archive-recipes'))) return false;

    let containerEl = document.querySelector('.gridder');
    let filterSelect = document.querySelector('#mixitup-filter-select');

    // If there is no container element, return
    if (!containerEl) return;

    let mixer = mixitup(containerEl);

    filterSelect.addEventListener('change', function() {
      mixer.filter(this.value);
    });

    Recipes.preSortRecipes(mixer);
  },
  getC7Product: function() {
    console.log(productSlugs); // coming from functions.php

    // Fetch data for each product slug
    productSlugs.forEach((slug) => {
      fetch(`https://api.commerce7.com/v1/product/slug/${slug}/for-web`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          tenant: 'rombauer-vineyards',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          // Select all matching .c7-buy-product elements
          const productElements = document.querySelectorAll(`.shop-prdt-listing__item[data-product-slug="${data.slug}"]`);
          productElements.forEach((productElement) => {
            // Insert image element
            const figureEl = `
                <figure>
                    <a href="/product/${data.slug}">
                        <picture><img src="${data.images[1].src}" alt="${data.title}"></picture>
                    </a>
                    <a href="/product/${data.slug}">View more details</a>
                </figure>
            `;
            const figureContainerElement = productElement.querySelector('.fig-cntr');
            if (figureContainerElement) {
              figureContainerElement.insertAdjacentHTML('afterbegin', figureEl);
            }

            // Insert title element
            const titleEl = `
                <a href="/product/${data.slug}">${data.title}</a>
            `;
            const titleContainerElement = productElement.querySelector('.title-cntr');
            if (titleContainerElement) {
              titleContainerElement.insertAdjacentHTML('afterbegin', titleEl);
            }
          });
        });
    });
  },

  waitForElement: function(slug, tries = 20) {
    let attempts = 0;

    const interval = setInterval(() => {
      attempts++;

      const productElement = document.querySelector(`.c7-buy-product`);

      if (productElement || attempts === tries) {
        clearInterval(interval);

        if (productElement) {
          // Run your getC7Product function here
          //if URL has 'recipes' in it, run getC7Product
          if (window.location.href.includes('recipes')) {
            Recipes.getC7Product();
          }
        } else {
          console.error(`.c7-buy-product not found after ${tries} attempts.`);
        }
      }
    }, 100);
  },
  init: function() {
    window.addEventListener('load', (event) => {
      setTimeout(() => {
        this.navUnderline();
        this.recipeMixitup();
        this.waitForElement();
      });
    });
  },
};

export default Recipes;
